// extracted by mini-css-extract-plugin
export var adCard = "_oe-8";
export var adCardBorder = "_oe-5";
export var arbiterButtonIcon = "_oe-p";
export var buttonIcon = "_oe-o";
export var container = "_oe-e";
export var copyButton = "_oe-m";
export var darkGrey = "_oe-u";
export var deliveryDate = "_oe-2";
export var divider = "_oe-n";
export var editModeWrapper = "_oe-7";
export var empty = "_oe-a";
export var errorIcon = "_oe-d";
export var filledCircle = "_oe-4";
export var fulfillmentFooter = "_oe-j";
export var grey = "_oe-s";
export var header = "_oe-i";
export var headerWrapper = "_oe-h";
export var highlighted = "_oe-6";
export var historyEntry = "_oe-3";
export var mobileColumn = "_oe-v";
export var mobileColumnReverse = "_oe-w";
export var orderDetailsContainer = "_oe-g";
export var orderMetadata = "_oe-l";
export var orderMetadataWrapper = "_oe-k";
export var packagesContainer = "_oe-b";
export var product = "_oe-y";
export var productImage = "_oe-z";
export var productInfo = "_oe-x";
export var productTitle = "_oe-10";
export var strikethrough = "_oe-t";
export var tinyText = "_oe-r";
export var title = "_oe-9";
export var trackerCard = "_oe-1";
export var trackerCardWrapper = "_oe-0";
export var trackingContainer = "_oe-f";
export var trackingTitle = "_oe-c";
export var xTinyText = "_oe-q";